export default __webpack_public_path__ + "static/media/quanta.f6421c18.png";